import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M21.577 22.19a.75.75 0 0 1 0 1.492l-.076.004h-7.4a.75.75 0 1 1 0-1.5h7.4zM16.57 9.505a.75.75 0 0 1 1.061 0l1.136 1.136a5.75 5.75 0 0 1 1.684 4.066v4.044l.482-.481a.75.75 0 0 1 1.061 1.061l-1.798 1.798a.75.75 0 0 1-1.051.01l-1.864-1.798-.053-.057a.75.75 0 0 1 1.036-1.073l.058.05.629.605v-4.158a4.25 4.25 0 0 0-1.244-3.005l-1.136-1.136a.75.75 0 0 1 0-1.061z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M7.178 2.232a3.57 3.57 0 0 1 4.696 1.848l1.225 2.814.697.015.378.03.076.011a.75.75 0 0 1-.225 1.481l-.267-.021 3.073 7.059a2.16 2.16 0 0 1-1.117 2.841l-5.681 2.474a2.16 2.16 0 0 1-2.842-1.118l-2.99-6.868-.094.126a.75.75 0 0 1-1.217-.877 10 10 0 0 1 .638-.794L2.235 8.277a3.57 3.57 0 0 1 1.847-4.696l3.097-1.349zm7.455 11.942c-.876.871-1.97 1.603-3.139 2.132-1.176.533-2.463.876-3.721.937l.795 1.824a.66.66 0 0 0 .867.342l5.681-2.474a.66.66 0 0 0 .341-.867zm-2.489-5.718a12.3 12.3 0 0 0-3.586 1.012c-1.213.546-2.333 1.271-3.248 2.114l1.813 4.163c1.196.049 2.518-.247 3.754-.807s2.333-1.358 3.104-2.266zm-1.646-3.778a2.07 2.07 0 0 0-2.722-1.07L4.68 4.956a2.07 2.07 0 0 0-1.07 2.723l1.07 2.459a14 14 0 0 1 3.263-2.037 14 14 0 0 1 3.578-1.073z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.577 1.789a.75.75 0 0 1 0 1.492l-.076.004h-7.4a.75.75 0 0 1 0-1.5h7.4z"
}));
const ForwardRef = forwardRef(SvgComponent);
export const CarParkingIcon = ForwardRef;